import { render, staticRenderFns } from "./field-list.vue?vue&type=template&id=987984a2&"
import script from "./field-list.vue?vue&type=script&lang=js&"
export * from "./field-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports